<template>
	<div >
		<nav-header :navText="headerText" class="mb-3" />
		<b-tabs content-class="mt-3 mx-4" v-model="tabIndex">

			<b-tab title="Click & Collect Desk" href="#desk" @click="tabEvent('#desk')" v-if="clickandcollectEnabled == 1">
				<b-row v-if="weekOneData.length > 1">
					<b-col cols="6" class="border p-4"><strong>Week one - {{ weekOneDateRange }} - Click & Collect Calendar</strong><week-slots-grid-configure :slots="weekOneData" :admin="true" week="weekOne" @show-form-modal="showFormModal" class="pt-2"/></b-col>
					<b-col cols="6" class="border p-4"><strong>Week two - {{ weekTwoDateRange }} - Click & Collect Calendar</strong><week-slots-grid-configure :slots="weekTwoData" :admin="true" week="weekTwo" @show-form-modal="showFormModal" class="pt-2"/></b-col>
				</b-row>
				<b-row v-if="weekThreeData.length > 1">
					<b-col cols="6" class="border p-4"><strong>Week three - {{ weekThreeDateRange }} - Click & Collect Calendar</strong><week-slots-grid-configure :slots="weekThreeData" :admin="true" week="weekThree" @show-form-modal="showFormModal" class="pt-2"/></b-col>
					<b-col cols="6" class="border p-4"><strong>Week four -  {{ weekFourDateRange }} - Click & Collect Calendar</strong><week-slots-grid-configure :slots="weekFourData" :admin="true" week="weekFour" @show-form-modal="showFormModal" class="pt-2"/></b-col>
				</b-row>
			</b-tab>
			<b-tab title="Click & Collect Locker" href="#locker" @click="tabEvent('#locker')" v-if="lockerEnabled == 1">
				<b-row v-if="weekOneData.length > 1">
					<b-col cols="6" class="border p-4"><strong>Week one - {{ weekOneLockerDateRange }} - Locker Calendar</strong><week-slots-grid-configure :slots="weekOneLockerData" :admin="true" @show-form-modal="showFormModal" class="pt-2"/></b-col>
					<b-col cols="6" class="border p-4"><strong>Week two - {{ weekTwoLockerDateRange }} - Locker Calendar</strong><week-slots-grid-configure :slots="weekTwoLockerData" :admin="true" @show-form-modal="showFormModal" class="pt-2"/></b-col>
				</b-row>
				<b-row v-if="weekThreeData.length > 1">
					<b-col cols="6" class="border p-4"><strong>Week three - {{ weekThreeLockerDateRange }} - Locker Calendar</strong><week-slots-grid-configure :slots="weekThreeLockerData" :admin="true" @show-form-modal="showFormModal" class="pt-2"/></b-col>
					<b-col cols="6" class="border p-4"><strong>Week four -  {{ weekFourLockerDateRange }} - Locker Calendar</strong><week-slots-grid-configure :slots="weekFourLockerData" :admin="true" @show-form-modal="showFormModal" class="pt-2"/></b-col>
				</b-row>			
			</b-tab>
			<b-tab title="Delivery" href="#delivery" @click="tabEvent('#delivery')" v-if="deliveryEnabled == 1">
				<b-row v-if="weekOneData.length > 1">
					<b-col cols="6" class="border p-4"><strong>Week one - {{ weekOneDeliveryDateRange }} - Delivery Calendar</strong><week-slots-grid-configure :slots="weekOneDeliveryData" :admin="true" @show-form-modal="showFormModal" class="pt-2"/></b-col>
					<b-col cols="6" class="border p-4"><strong>Week two - {{ weekTwoDeliveryDateRange }} - Delivery Calendar</strong><week-slots-grid-configure :slots="weekTwoDeliveryData" :admin="true" @show-form-modal="showFormModal" class="pt-2"/></b-col>
				</b-row>
				<b-row v-if="weekThreeData.length > 1">
					<b-col cols="6" class="border p-4"><strong>Week three - {{ weekThreeDeliveryDateRange }} - Delivery Calendar</strong><week-slots-grid-configure :slots="weekThreeDeliveryData" :admin="true" @show-form-modal="showFormModal" class="pt-2"/></b-col>
					<b-col cols="6" class="border p-4"><strong>Week four -  {{ weekFourDeliveryDateRange }} - Delivery Calendar</strong><week-slots-grid-configure :slots="weekFourDeliveryData" :admin="true" @show-form-modal="showFormModal" class="pt-2"/></b-col>
				</b-row>			
			</b-tab>
		</b-tabs>
		<b-modal id="formModal" :title="'Add ' + typeText" hide-footer  no-close-on-esc no-close-on-backdrop hide-header-close>
			<b-row>
				<b-col>
					<div v-if="!inCredit">
					<p>Unfortunately there is insufficient credit to add any further orders - please top up your account using the link below:</p>
						<b-button href="http://localhost/scanandget/public_html/billing/billing.php#tabs-4">Add Credit</b-button>
						<b-button  class="float-right" variant="danger" @click="cancel()">Cancel</b-button>
					</div>
					<b-form @submit="onSubmit" @reset="onReset" class="text-left" validated ref="formContainer" v-if="inCredit">
						<div v-if="!formSubmitted">
						<p><strong> {{ selectedSlotDate |  moment("ddd D MMM")  }} {{ selectedSlotTime }}</strong></p>
						<b-form-group id="customerNameGroup" description="Salutaion in SMS message text.">
							<label for="customer-name" class="sr-only">Customer Name</label>
							<b-form-input
							id="customerName"
							v-model="form.customerName"
							required
							:state="customerNameState"
							placeholder="Enter customer name"
							></b-form-input>
							<b-form-invalid-feedback>A customer name is required</b-form-invalid-feedback>
						</b-form-group>
						
						<b-form-group id="orderMobileNumberGroup" description="The mobile number where the SMS collection details will be sent to.">
							<label for="orderMobileNumber" class="sr-only">Mobile number</label>
							<b-form-input
							id="orderMobileNumber"
							v-model="form.orderMobileNumber"
							:state="orderMobileNumberState"
							type="tel"
							required
							placeholder="Order mobile number"
							></b-form-input>
							<b-form-invalid-feedback>A mobile number is required</b-form-invalid-feedback>
						</b-form-group>
						
						<b-form-group id="orderEmailGroup" description="">
							<label for="orderEmail" class="sr-only">Email address</label>
							<b-form-input
							id="orderEmail"
							v-model="form.orderEmail"
							:state="orderEmailState"
							type="email"
							required
							placeholder="Order Email"
							></b-form-input>
							<!--<b-form-invalid-feedback>Please enter a valid email address</b-form-invalid-feedback>-->			
						</b-form-group>
						
						<b-form-group id="orderIdGroup" description="">
							<label for="orderId" class="sr-only">Order Id</label>
							<b-form-input
							id="orderId"
							v-model="form.orderId"
							:state="orderIdState"
							type="text"
							required
							placeholder="Order Id"
						></b-form-input>
						<b-form-invalid-feedback>An order id is required</b-form-invalid-feedback>
						</b-form-group>
						
					
							<b-button type="submit" variant="primary" class="mr-2">Submit</b-button>
							<b-button type="reset" variant="danger" class="mr-2">Reset</b-button>
							<b-button  variant="danger" @click="cancel()">Cancel</b-button>
						</div>
					</b-form>
				</b-col>
			</b-row>
		</b-modal>
	</div>
</template>

<script>
import NavHeader from './NavHeader'
import {RepositoryFactory} from '../api/RepositoryFactory'
import {mixin} from '../mixins/clickAndCollectMixins'
import EventBus from './../eventBus';
//const SlotsRepo = RepositoryFactory.get('slots')
const SlotsRepoPost = RepositoryFactory.post('slots')
import WeekSlotsGridConfigure from './WeekSlotsGridConfigure'
//import moment from 'moment'
export default{
	name: 'DesktopConfigureSlotCalendar',
	components: {WeekSlotsGridConfigure, NavHeader},
	mixins: [mixin],
		data(){
			return{
				clickandcollectEnabled: this.$store.state.settings.clickandcollectEnabled,
				lockerEnabled: this.$store.state.settings.lockerEnabled,
				deliveryEnabled: this.$store.state.settings.deliveryEnabled,
				renderKey: 0,
				tabIndex: 0,
				tabs: ['#desk', '#locker', '#delivery'],
				headerText: "Click&Collect - Manage Slots",
				weekOneDateRange : "",
				weekOneData: [],
				weekTwoDateRange : "",
				weekTwoData: [],				
				weekThreeDateRange : "",				
				weekThreeData: [],
				weekFourDateRange : "",				
				weekFourData: [],
				weekOneLockerDateRange : "",
				weekOneLockerData: [],
				weekTwoLockerDateRange : "",
				weekTwoLockerData: [],				
				weekThreeLockerDateRange : "",				
				weekThreeLockerData: [],
				weekFourLockerDateRange : "",				
				weekFourLockerData: [],
				weekOneDeliveryDateRange : "",
				weekOneDeliveryData: [],
				weekTwoDeliveryDateRange : "",
				weekTwoDeliveryData: [],				
				weekThreeDeliveryDateRange : "",				
				weekThreeDeliveryData: [],
				weekFourDeliveryDateRange : "",				
				weekFourDeliveryData: [],
				form: {
					customerName: '',
					orderEmail: '',
					orderMobileNumber: '',
					orderId: '',
					slotId:	'',
					slotType: '',
					slotTime: ''
				},
				typeText: '',
				selectedSlotDay: '',
				selectedSlotDate: '',
				selectedSlotTime: '',
				selectedSlotId: '',
				selectedSlotType: '',
				fullPage: false,
				formSubmitted: false,
				inCredit: false
		}
	},
	created(){
		this.fetchGetLockerSlotsDesktop();
		this.fetchGetClickAndCollectSlotsDesktop();
		this.fetchGetDeliverySlotsDesktop();
	},
	methods:{
		cancel(){
			this.$bvModal.hide("formModal")
		},
		reloadPage(){
			location.reload('http://localhost:8081/#locker');
		},
		showFormModal(event){
			console.log(event)
			//this.typeText = (event.slotType === 'locker')? 'Locker Booking' : 'Click and Collect Booking'
			switch(event.slotType)
			{
				case 'locker':
				this.typeText = 'Locker Booking';
				break;
				case 'clickandcollect':
				this.typeText = 'Click and Collect Booking';
				break;
				case 'delivery':
				this.typeText = 'Delivery';
				break
			}
			this.selectedSlotDay = event.slotDay
			this.selectedSlotDate = event.slotDate
			this.selectedSlotTime = event.slotTime
			this.selectedSlotType = event.slotType
			this.form.slotType = event.slotType
			this.form.slotDate = event.slotDate
			this.form.slotTime = event.slotTime
			this.form.slotId = event.slotId
			
			this.$bvModal.show("formModal")
		},		
		onSubmit(evt) {
			console.log(evt)
			evt.preventDefault()
			this.PostAddBooking()
			this.formSubmitted = true
			let loader = this.$loading.show({
			container: this.fullPage ? null : this.$refs.formContainer,
			canCancel: false,
			onCancel: this.onCancel,
			loader: 'dots',
			color: 'green',
			opacity: 0.5,
			});
			
			this.$nextTick().then(() => {
				setTimeout(() => {
				loader.hide()	
				this.reloadPage()				
			}, 1500)
			});				

					
		},
		emitMethod(){
			EventBus.$emit('ForceUpdate');
		},
		onReset(evt) {
			evt.preventDefault()
			// Reset our form values
				this.form.orderEmail = ''
				this.form.customerName = ''
				this.form.orderMobileNumber= ''
				this.form.orderId = ''
			// Trick to reset/clear native browser form validation state
				this.show = false
				this.$nextTick(() => {
				this.show = true
			})
		},
		async PostAddBooking(){
		var payload = new FormData();
		for ( var key in this.form ) {
			payload.append(key, this.form[key]);
		}	
			await SlotsRepoPost.postAddSlotBooking(payload)
		},
		tabEvent(hash)
		{
			window.location = hash
		}
	},
	computed:{
		customerNameState(){
			return this.form.customerName.length >= 2 ? true : false;
		},
		orderMobileNumberState(){
			return this.form.orderMobileNumber.length == 11 ? true : false;
		},
		orderEmailState(){
			return this.form.orderEmail.length == "derekmwanza@hotmail.co.uk" ? true: false; 
		},
		orderIdState(){
			return this.form.orderId.length >= 2? true : false;
		}
	},
	mounted() {
		this.tabIndex = this.tabs.findIndex(tab => tab === this.$route.hash)			
	}
}

</script>

<style>
.vld-icon {
    text-align: center
}
</style>
